define('lib/validator/ValidatorStringLengthGreaterThan',['require','lib/validator/ValidatorAbstract'],function (require) {

    var ValidatorAbstract = require('lib/validator/ValidatorAbstract');

    return ValidatorAbstract.extend({

        options : {
            value : null,
            error : 'error_string_not_greate_than',
        },

        /**
         * Validates value
         *
         * @param mixed value
         */
        validate: function (value) {
            if (!_.isEmpty(value) && String(value).length < this.options.value) {
                this.addError(this.options.error);
            }
        }

    });

});
